import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Renderer2, TemplateRef,
} from "@angular/core";

import {
  CalendarOptions,
  DateSelectArg,
  EventClickArg,
  EventApi,
  EventInput,
} from "@fullcalendar/core";
import { Draggable } from "@fullcalendar/interaction"; // for dateClick
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid"; // a plugin!
import listPlugin from "@fullcalendar/list"; // a plugin!
import interactionPlugin from "@fullcalendar/interaction"; // a plugin!
import {
  INITIAL_EVENTS,
  hideEventDescription,
  showEventDescription,
} from "src/app/Shared/events";
import {
  ModalDismissReasons,
  NgbAccordionConfig,
  NgbAccordionModule, NgbModal, NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TaxCalculatorService } from "../../../Services/assessments/tax-calculator.service";
import {
    EarnedIncome, NewDirectTax,
    Relief,
    TaxDeduction,
    TaxRelief,
    TaxWithheld,
    UnEarnedIncome,
} from "../../../models/direct-tax.model";
import { result } from "lodash";
import { FullCalendarComponent } from "@fullcalendar/angular";
import {interval, map, Observable, Subscription, timer} from "rxjs";
import { Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { VaidsDeadlineModalComponent } from "../../Users/vaids/components/vaids-deadline-modal/vaids-deadline-modal.component";

const DEADLINE_YEAR = 2026;
const DEADLINE_MONTH_INDEX = 8;
const DEADLINE_DATE = 5;

@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.css"],
})
export class LandingPageComponent implements OnInit {
  calendarVisible = false;
  years: number[] = [];
  countDown: Subscription;
  countDown$: Observable<any>;
  counter = 1800;
  tick = 1000;
  future = new Date('2026-01-31T00:00:00.000Z');

  accordionIds: {
    income: string;
    deduction: string;
    taxesWithheld: string;
    reliefs: string;
  } = {
    income: "income",
    deduction: "deduction",
    taxesWithheld: "taxesWithheld",
    reliefs: "reliefs",
  };
  // slider images
  slides = [
    {
      type: "vaids",
      image: "",
      btnText: "Get Started Now",
    },
    {
      type: "taas",
      image: "",
      btnText: "Apply for Accreditation",
    },
    {
      type: "tama",
      image: "",
      btnText: "Become an Agent",
    },
    { image: "/assets/img/new-slide-2.png", btnText: "Get Started" },
    { image: "/assets/img/new-slide-3.jpg", btnText: "Learn more..." },
    { image: "/assets/img/new-slide-2.jpg", btnText: "Verify Your AIRS" },
    { image: "/assets/img/new-slide-4.jpg", btnText: "Learn more..." },
    // {image: '/assets/img/new-slide-111.png', btnText: 'Learn more...'}
  ];

  @ViewChild("fullCalendar") fullCalendar!: FullCalendarComponent;

  calendarOptions: CalendarOptions = {
    headerToolbar: {
      left: "prev,today,next",
      right: "title",
      // right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
    },
    plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
    initialView: "dayGridMonth",
    initialEvents: INITIAL_EVENTS,
    events: INITIAL_EVENTS,
    weekends: true,
    editable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    eventClick: this.handleEventClick.bind(this),
    eventsSet: this.handleEvents.bind(this),
  };

  calculatorForm: any = FormGroup;
  currentEvents: EventApi[] = [];
  totalTaxPayable: number = 0;
  result: any;
  activeAccordion: string;
  modalOptions: NgbModalOptions;
  closeResult: string;

  private vaidsDeadline: Date = new Date(DEADLINE_YEAR, DEADLINE_MONTH_INDEX, DEADLINE_DATE);

  constructor(
    config: NgbAccordionConfig,
    private fb: FormBuilder,
    private taxCalculator: TaxCalculatorService,
    private rendere: Renderer2,
    private modalService: NgbModal,
    private router: Router,
    private readonly bsModalService: BsModalService, 
  ) {
    config.closeOthers = true;
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      keyboard: false,
      centered: true,
    };
  }

  startTaasAccreditation(): void {
    this.router.navigate(["/auth/login"], {
      queryParams: { returnUrl: "/user/taas" },
    });
  }

  startTamaRegistration(): void {
    this.router.navigate(["/tama/registration/register"]);
  }
  @ViewChild('notification', { static: true })
  notificationModal!: TemplateRef<any>;

  loadScript() {
    const script = document.createElement("script");
    script.innerHTML = "";
    script.src = "//code.jivosite.com/widget/W7i2rdHOw9";
    script.async = true;
    script.defer = true;

    this.rendere.appendChild(document.body, script);
  }

  ngOnInit(): void {
    this.toggleActiveAccordion(this.accordionIds.income);
    this.calculatorForm = this.fb.group({
      year: [""],
      employment: [""],
      trade: [""],
      pension: [""],
      iconsultation: [""],
      idirector: [""],
      gratuities: [""],
      bonus: [""],
      others: [""],
      rent: [""],
      commission: [""],
      consultation: [""],
      directors: [""],
      contract: [""],
      wothers: [""],
      nhf: [""],
      nhis: [""],
      lap: [""],
      children: [""],
      wpension: [""],
      wrent: [""],
      dividend: [""],
      interest: [""],
      royalty: [""],
      irent: [""],
      profit: [""],
    });
    // this.handleEventClick.bind(this)
    // this.handleEvents.bind(this)
    // Defer heavy work until after initial paint
    setTimeout(() => {
      this.calendarVisible = true;
      this.loadScript();
      this.countDown = timer(0, this.tick).subscribe(() => --this.counter);
    }, 300);
    this.countDown$ = interval(1000).pipe(
        map(x => {
          return Math.floor((this.future.getTime() - new Date().getTime()) / 1000);
        })
    );
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 2020; year--) {
      this.years.push(year);
    }

    // VAIDS popup modal
    if (Date.now() < this.vaidsDeadline.getTime()) this.initVaidsModal();
  }

  private initVaidsModal() {
    const dfModalRef = this.bsModalService.show(VaidsDeadlineModalComponent, {
      initialState: {
        deadline: this.vaidsDeadline.toISOString(),
      },
      class: "rounded-5 overflow-hidden",
      ignoreBackdropClick: true,
    });

    dfModalRef?.content?.continue.subscribe(() => {
      dfModalRef?.hide();
      this.router.navigate(['user','vaids']);
    })
  }

  popUp() {
    const element: HTMLElement = document.getElementById('modal') as HTMLElement;
    element.click();
  }

  notificationPop(content: TemplateRef<any>) {
    this.modalOptions.size = 'lg';
    this.modalOptions.ariaLabelledBy = 'modal-basic-title';
    this.modalService.open(content, this.modalOptions).result.then(
        result => {
          this.closeResult = `Closed with: ${result}`;
        },
        reason => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  handleEventClick(clickInfo: EventClickArg) {
    // show event in a popup
    alert(clickInfo.event.title);

    // if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
    //   clickInfo.event.remove();
    // }
  }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
  }

  earned_unearned = true;
  toggleValue = "calc-close";
  toggleState = false;

  toggle_button(bool) {
    this.earned_unearned = bool;
  }

  toggleCalculator() {
    this.toggleState = !this.toggleState;
    this.toggleValue = this.toggleState ? "calc-open" : "calc-close";
  }

  calculateTax() {
    const earnedIncome: EarnedIncome = {
      trade: Number(this.calculatorForm.value.trade.split(",").join("")),
      employment: Number(
        this.calculatorForm.value.employment.split(",").join(""),
      ),
      consultation: Number(
        this.calculatorForm.value.iconsultation.split(",").join(""),
      ),
      director: Number(this.calculatorForm.value.idirector.split(",").join("")),
      profit: Number(this.calculatorForm.value.profit.split(",").join("")),
    };

    const unEarnedIncome: UnEarnedIncome = {
      dividend: Number(this.calculatorForm.value.dividend.split(",").join("")),
      interest: Number(this.calculatorForm.value.interest.split(",").join("")),
      royalty: Number(this.calculatorForm.value.royalty.split(",").join("")),
      rent: Number(this.calculatorForm.value.irent.split(",").join("")),
    };

    const taxDeduction: TaxDeduction = {
      pension: Number(this.calculatorForm.value.pension.split(",").join("")),
      gratuities: Number(
        this.calculatorForm.value.gratuities.split(",").join(""),
      ),
      otherIncome: Number(this.calculatorForm.value.others.split(",").join("")),
      bonus: Number(this.calculatorForm.value.bonus.split(",").join("")),
    };

    const taxWithheld: TaxWithheld = {
      rent: Number(this.calculatorForm.value.rent.split(",").join("")),
      commission: Number(
        this.calculatorForm.value.commission.split(",").join(""),
      ),
      consultation: Number(
        this.calculatorForm.value.consultation.split(",").join(""),
      ),
      directors: Number(
        this.calculatorForm.value.directors.split(",").join(""),
      ),
      contract: Number(this.calculatorForm.value.contract.split(",").join("")),
      others: Number(this.calculatorForm.value.wothers.split(",").join("")),
    };

    const relief: TaxRelief = {
      nhf: Number(this.calculatorForm.value.nhf.split(",").join("")),
      nhis: Number(this.calculatorForm.value.nhis.split(",").join("")),
      lap: Number(this.calculatorForm.value.lap.split(",").join("")),
      children: Number(this.calculatorForm.value.children.split(",").join("")),
      pension: Number(this.calculatorForm.value.wpension.split(",").join("")),
      rent: Number(this.calculatorForm.value.wrent.split(",").join("")),
    };

    if(this.calculatorForm.value.year != ""){
      if(Number(this.calculatorForm.value.year) >= 2026){
        this.result = this.taxCalculator.getNewTaxPayable(earnedIncome, unEarnedIncome, relief,);
      }else{
        this.result = this.taxCalculator.getTaxPayable(taxWithheld, earnedIncome, unEarnedIncome, taxDeduction, relief)
      }
    }

    this.totalTaxPayable = this.result.totalTaxPayable;
  }

  detailsBoolean = false;

  computeDetails() {
    this.detailsBoolean = !this.detailsBoolean;
  }

  toggleActiveAccordion(accordionId: string): void {
    this.activeAccordion = accordionId;
  }

  showPopOut = 0;

  togglePopOut(int) {
    if (this.showPopOut === int) {
      this.showPopOut = 0;
      return;
    }
    this.showPopOut = int;
  }

  customDayCell(arg: { date: Date; dayEl: HTMLElement }): void {
    const today = new Date();
    if (
      arg.date.getFullYear() === today.getFullYear() &&
      arg.date.getMonth() === today.getMonth() &&
      arg.date.getDate() === today.getDate()
    ) {
      arg.dayEl.classList.add("today-event");
    }
  }
}
